// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"styles-module--textBlock--2bBao","buttonGroup":"styles-module--buttonGroup--3I47f","projectTickers":"styles-module--projectTickers--2MbM8"};